"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var HeaderTopResults = function HeaderTopResults(props) {
  var data = props.data,
    partNumberLabel = props.partNumberLabel,
    isEProc = props.isEProc;
  var handleItemClick = function handleItemClick(item) {
    props.handleAnalyticsForTopResults(item);
  };
  var renderView = function renderView(item, index) {
    var skuPageHref = isEProc ? item.eprocUrl : item.url;
    return _react.default.createElement("div", {
      className: "cmp-sku-list-top-result__container ",
      role: "option",
      id: "listbox-top-result-" + index,
      "data-locator": "search-bar-top-result"
    }, _react.default.createElement("div", {
      className: "cmp-sku-list-top-result__left"
    }, _react.default.createElement("img", {
      src: item.thumbnail,
      alt: item.title,
      "data-locator": "search-bar-top-result-product-image"
    })), _react.default.createElement("div", {
      className: "cmp-sku-list-top-result__right"
    }, _react.default.createElement("span", {
      className: "cmp-sku-list-top-result__code",
      "data-locator": "search-bar-top-results-product-number",
      "aria-label": partNumberLabel + " " + item.skucode
    }, partNumberLabel + " " + item.skucode), _react.default.createElement("div", null, _react.default.createElement(_Anchor.default, (0, _extends2.default)({
      className: "cmp-sku-list-top-result__title",
      to: skuPageHref || null,
      as: skuPageHref || null,
      title: item.title,
      "aria-label": item.title,
      elementLocator: "search-bar-top-result-product-title"
    }, {
      handleLinkClick: function handleLinkClick(e) {
        e.preventDefault();
        handleItemClick(item.skucode);
        window.location.href = skuPageHref;
      }
    }), item.title))));
  };
  return data.map(function (item, index) {
    return renderView(item, index);
  });
};
HeaderTopResults.defaultProps = {
  className: '',
  data: [],
  partNumberLabel: '',
  handleAnalyticsForTopResults: function handleAnalyticsForTopResults() {
    /* default top result handler */
  }
};
var _default = HeaderTopResults;
exports.default = _default;
module.exports = exports["default"];